import React from 'react';
import './Skeleton.css';

const AttendanceSkeleton = ({ rows = 5, days = 31 }) => {
  return (
    <div className="skeleton-wrapper">
      <table className="skeleton-table">
        <thead>
          <tr>
            <th className="skeleton-heading">
              <div className="skeleton-line student-header"></div>
            </th>
            {Array.from({ length: days }).map((_, index) => (
              <th key={index} className="skeleton-heading">
                <div className="skeleton-line date-cell"></div>
              </th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: rows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              <td className="skeleton-cell student-info">
                <div className="skeleton-line name"></div>
                <div className="skeleton-line roll"></div>
              </td>
              {Array.from({ length: days }).map((_, cellIndex) => (
                <td key={cellIndex} className="skeleton-cell">
                  <div className="skeleton-checkbox"></div>
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AttendanceSkeleton;
